export default __webpack_public_path__ + "static/media/banner_portrait.cc0b6d7a.jpg";